module.exports = __webpack_public_path__ + "static/media/budweiser_boomerang01.813a8e7f.webm";